"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openFileInput = exports.asyncCraftImageBuffer = exports.craftImageBuffer = void 0;
const tslib_1 = require("tslib");
/* eslint-disable no-console */
const IMG_EL = "img";
const CANVAS_EL = "canvas";
const CTX_2D_TYPE = "2d";
const calculateSize = (data) => {
    let width = data.startWidth;
    let height = data.startHeight;
    if (width > height) {
        if (width > data.maxSize) {
            height *= data.maxSize / width;
            width = data.maxSize;
        }
    }
    else {
        if (height > data.maxSize) {
            width *= data.maxSize / height;
            height = data.maxSize;
        }
    }
    return { width, height };
};
const extractImageData = (canvas) => canvas.toDataURL("image/jpeg").split(",")[1];
const craftImageBuffer = (file, maxSize, onResolve) => {
    const reader = new FileReader();
    reader.onload = () => {
        const image = document.createElement(IMG_EL);
        image.onload = () => {
            const canvas = document.createElement(CANVAS_EL);
            const ctx = canvas.getContext(CTX_2D_TYPE);
            if (ctx) {
                ctx.drawImage(image, 0, 0);
                const { width, height } = calculateSize({
                    startWidth: image.width,
                    startHeight: image.height,
                    maxSize,
                });
                canvas.width = width;
                canvas.height = height;
                ctx.drawImage(image, 0, 0, width, height);
                const buffer = Buffer.from(extractImageData(canvas), "base64");
                onResolve(buffer);
            }
            else {
                console.log("Context does not exist");
            }
        };
        if (reader.result) {
            image.src = reader.result;
        }
        else {
            console.log("Reader result is null");
            reader.abort();
        }
    };
    reader.readAsDataURL(file);
};
exports.craftImageBuffer = craftImageBuffer;
const asyncCraftImageBuffer = (file, size) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve) => exports.craftImageBuffer(file, size, resolve));
});
exports.asyncCraftImageBuffer = asyncCraftImageBuffer;
const openFileInput = (onResolve, onError, inputType) => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", inputType);
    input.click();
    input.onchange = () => {
        if (input.files && input.files.length > 0) {
            const file = input.files[0];
            const url = URL.createObjectURL(file);
            onResolve(file, url);
        }
        else {
            onError("Arquivo selecionado é inválido");
        }
    };
};
exports.openFileInput = openFileInput;
